// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"452":"912e6bd8b4720926f257","896":"f8ff74072a730470c211"}[chunkId] + ".js";
};